import { thirdPartyMediatorService, thirdPartySupportService, thirdPartyAppEvents } from '../third-party/service';
import { IframeApp } from '../third-party/interface/iframe-app';

export class NavFeedbackButton extends HTMLElement {
  connectedCallback(): void {
    this.setAttribute('aria-label', 'feedback');
    this.addEventListener('click', () => {
      thirdPartyMediatorService.openFeedbackApplication();
    });
    thirdPartySupportService.on(thirdPartyAppEvents.UPDATE_APP, this.setVisible.bind(this));
  }

  setVisible(appData: IframeApp): void {
    /* istanbul ignore next else */
    if (appData && appData.active) {
      const isVisible = thirdPartyMediatorService.isFeedbackButtonVisible();
      if (isVisible) {
        this.classList.remove('hidden');
      } else {
        this.classList.add('hidden');
      }
    }
  }

}

window.customElements.define('nav-feedback-button', NavFeedbackButton);
